<template>
    <div :class="'mHead ' + classType">
        <div class="top">
            <template v-if="showBack">
                <em class="backBtn left" @click="goBack"></em>
            </template>
            <template v-else>
                <img class="navIcon left" v-if="classType == 'light'"  @click="changeShow(true)" src="@/assets/img/ic_caidan@3x.png" alt="">
                <img class="navIcon left" v-else @click="changeShow(true)" src="@/assets/img/ic_caidan@2x.png" alt="">
            </template>
            <span v-if="title">{{title}}</span>
            <img v-else-if="classType == 'light'" class="corange light" src="@/assets/img/Group 138 2@3x.png" alt="">
            <img v-else class="corange" src="@/assets/img/CORANGE@3x.png" alt="">
            <img class="searchIcon right" v-if="classType == 'light' && showSearch" @click="openSearch" src="@/assets/img/ic_sousuo@3x.png" alt="">
            <img class="searchIcon right" v-else-if="showSearch" src="@/assets/img/ic_sousuo@2x.png" @click="openSearch" alt="">
        </div>
        <div v-show="show" class="nav">
            <div class="navTop">
                <img class="navIcon left" @click="changeShow(false)" src="@/assets/img/ic_guanbi@2x.png" alt="">
                <img class="corange" src="@/assets/img/CORANGE@3x.png" alt="">
                <img class="searchIcon right" src="@/assets/img/ic_sousuo@3x.png" alt="">
            </div>
            <div class="navList">
                <div :class="'item' + (item.key == selectedNav ? ' on' : '')" v-for="item in navList" :key="item.id">
                    <p @click="toPage(item)"><em v-show="!item.showChildres">+</em><em v-show="item.showChildres">-</em><span>{{ item.navName }}</span><p>
                    <div class="miniItemBox" v-show="item.childrens && item.showChildres">
                        <div :class="'miniItem' + (em.id == selectedChildNav ? ' on' : '')" v-for="em in item.childrens" :key="em.id">
                            <p @click="toPage(em)">{{em.navName}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="searchBox" v-show="searchOpen">
            <div class="inputBox">
                <img class="searchIcon" src="@/assets/img/ic_sousuo@3x.png" alt="">
                <input type="text" placeholder="搜索" v-model="searchKey"  @focus="focus" @blur="blur" @input="change">
                <span @click="searchOpen=false">取消</span>
            </div>
            <div class="resultBox">
                <div class="result" v-show="searchKey.length > 0">
                    {{list.length}}个搜索结果
                </div>
                <div class="list">
                    <div class="item" v-for="item in list" :key="item.id +'-'+ (item.caseName || item.name)" @click="toDetail(item)">
                        <p class="title">{{item.name || item.caseName}}</p>
                        <p class="desc">{{item.remarks}}</p>
                        <p class="url"><a href="javascript:;">{{ 'http://www.corange.com/#/' + ( item.caseName ? 'detail' : 'businessDetail' ) + '/' + item.id}}</a></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations} from 'vuex'
export default {
    inject: ['reload'],
    name: 'mHead',
    computed:{
        ...mapState(['caseTypeList']),
        list: function() {
            let list = []
            if(this.searchKey.length > 0){
                list = this.allList.filter(item => {
                    return (item.caseName && item.caseName.indexOf(this.searchKey) > -1) || (item.name && item.name.indexOf(this.searchKey) > -1)
                })
            }
            return list || []
        }
    },
    data(){
        return {
            show: false,
            searchOpen: false,
            searchKey: '',
            allList: [],
            selectedNav: 'home',
            selectedChildNav: '',
            navList: [
                {
                    id: '-1',
                    key: 'home',
                    navName: '首页',
                    url: '/home'
                },
                {
                    id: '-2',
                    key: 'case',
                    navName: '案例',
                    childrens: [
                        
                    ]
                },
                {
                    id: '-3',
                    key: 'about',
                    navName: '青橙',
                    url: '/about'
                },
                {
                    id: '-4',
                    key: 'business',
                    navName: '资讯',
                    url: '/business'
                },
                {
                    id: '-5',
                    key: 'joinUs',
                    navName: '加入我们',
                    url: '/joinUs'
                }
            ]
        }
    },
    props:['title','classType','showSearch','showBack'],
    mounted(){
        let name = this.$route.name;
        if (name == 'other') {
            name = 'home'
        }
        this.selectedNav = name;
        if (this.caseTypeList && this.caseTypeList.length > 0) {
            this.dealCaseTypeList(this.caseTypeList)
        } else {
            this.getList();
        }
    },
    methods: {
        ...mapMutations(['setCaseTypeList']),
        goBack(){
            history.back();
        },
        openSearch(){
            this.searchOpen = true;
            if(this.allList.length == 0) {
                this.getInfoList();
                this.getCaseList();
            }
        },
        focus(){
           
        },
        change(){
            if(this.allList.length == 0) {
                this.getInfoList();
                this.getCaseList();
            }
        },
        blur(){
            
        },
        toDetail(item) {
            let url = '/' + (item.caseName ? 'detail' : 'businessDetail') + '/' + item.id;
            this.$router.push(url)
        },
        getInfoList(){
            this.$http.get(this.service.dev.api.infoList ).then(response =>{
              if(response.status == 200){
                  let list = (response.body || []).filter(item => {
                      return item.status == 1;
                  })

                  this.allList = [...list, ...this.allList];
              } else {
                  this.$message.error(response.message?response.message:'error');
              }
          }).catch((res)=>{
              this.$message.error('error');
          })
        },
        getCaseList(){
            this.$http.get(this.service.dev.api.caseList ).then(response =>{
              if(response.status == 200){
                  let list = (response.body || []).filter(item => {
                      return item.status == 1;
                  })

                  this.allList = [...list, ...this.allList];
              } else {
                  this.$message.error(response.message?response.message:'error');
              }
          }).catch((res)=>{
              this.$message.error('error');
          })
        },
        getList(){
            this.$http.get(this.service.dev.api.recommendList+'?pageId=8' ).then(response =>{
                if (response.status == 200) {
                    let list = response.body || [];
                    this.dealCaseTypeList(list);
                    this.setCaseTypeList(list);
                } else {
                    this.$message.error(response.message?response.message:'error');
                }
            }).catch((res)=>{
                this.$message.error('error');
            })
        },
        dealCaseTypeList(list){
            let id = '';
            if (this.$route.name == 'case') {
                id = this.$route.params.id;
                this.navList[1].showChildres = true;
            }
            list.map(item => {
                if (item.keyName == 'caseTypeList') {
                    this.navList[1].childrens.push({id: item.id, ischildren: true, navName: item.keyDesc, url: '/case'});
                }
                if (item.id == id) {
                    this.selectedChildNav = id;
                }
            })
        },
        changeShow(show){
            this.show = show;
        },
        toPage(item){
            if (item.childrens) {
                if (item.showChildres) {
                    item.showChildres = false;
                } else {
                    this.$set(item, 'showChildres', true);
                }
            } else {
                this.show = false;
                if (item.ischildren) {
                    let name = this.$route.name;
                    this.$router.push({ path : item.url + '/' + item.id })
                    if (name == 'case') {
                        this.reload();
                    }
                } else {
                    this.$router.push(item.url);
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
   @import "@/assets/style/base.scss";
    .mHead {
        position: relative;
        z-index: 99;
        .searchBox {
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background: #ffffff;
            padding: poToRem(18);
            box-sizing: border-box;
            .inputBox {
                display: flex;
                justify-content: space-between;
                align-items: center;
                position: relative;
                padding-bottom: poToRem(10);
                input {
                    flex: 1;
                    margin: 0 poToRem(12);
                    border: none;
                    height: poToRem(32);
                    padding: 0 poToRem(12);
                    border-color: #ffffff;
                }
                span {
                    font-size: poToRem(14);
                }
                &:after {
                    position: absolute;
                    box-sizing: border-box;
                    content: " ";
                    pointer-events: none;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                    transform: scaleY(.5);
                }
            }
            .resultBox {
                width: 100%;
                text-align: left;
                .result {
                    padding: poToRem(30) 0px;
                    box-sizing: border-box;
                    font-size: poToRem(12);
                    color: rgba(0, 0, 0, 0.6);
                }
                .list {
                    // padding: 40px 0 80px 200px;
                    width: 100%;
                    box-sizing: border-box;
                    max-height: calc(100vh - poToRem(32) - poToRem(90));
                    overflow-y: auto;
                    .item {
                        margin-bottom: poToRem(30);
                        .title {
                            font-size: poToRem(16);
                            color: #000000;
                            width: 100%;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                        .desc {
                            width: 100%;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            font-size: poToRem(14);
                            color: rgba(0,0,0,0.4);
                            margin: poToRem(6) 0;
                        }
                        .url {
                            a {
                                font-size: poToRem(14);
                                color: #327FDA;
                                text-decoration: none; 
                                display: block;
                            }
                        }

                    }
                    &::-webkit-scrollbar {
                        width: poToRem(4);
                    }
                    &::-webkit-scrollbar-thumb {
                        border-radius: poToRem(10);
                        -webkit-box-shadow: inset 0 0 poToRem(5) rgba(0,0,0,0.2);
                        opacity: 0.2;
                    }
                }
            }
        }
        &.light {
            .top {
                background: rgba(255,255,255,1);
                span {
                    color: #000;
                }
            }
        }
        .top {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            padding: poToRem(15) poToRem(16);
            box-sizing: border-box;
            background: rgba(0,0,0,0.9);
            height: poToRem(54);
            span {
                color: #ffffff;
                font-size: poToRem(16);
                vertical-align: top;
                line-height: poToRem(24);
                height: poToRem(24);
                display: inline-block;
            }
            .backBtn {
                height: 100%;
                &::after {
                    content: '';
                    display: inline-block;
                    width: poToRem(14);
                    height: poToRem(14);
                    border: poToRem(2) solid #000;
                    border-bottom: none;
                    border-left: none;
                    -webkit-transform: rotate(-135deg) translateY(poToRem(6));
                    transform: rotate(-135deg) translateY(poToRem(6));
                    margin-right: poToRem(5);
                }
            }
        }
        .nav {
            position: fixed;
            top: 0 ;
            bottom: 0;
            left: 0;
            right: 0;
            background: rgba(0, 0, 0, 0.94);
            padding: poToRem(15) poToRem(16) 0;
            .navList {
                text-align: left;
                padding: poToRem(30) poToRem(4);
                .item {
                    font-size: poToRem(20);
                    color: rgba(255, 255, 255, 0.4);
                    line-height: poToRem(27);
                    margin-bottom: poToRem(16);
                    em {
                        font-style: normal;
                        display: inline-block;
                        width: poToRem(12);
                    }
                    >p span{
                        padding-left: poToRem(10);
                    }
                    &.on p span, &.on p em{
                        color: rgba(255, 255, 255, 1);
                    }
                    .miniItemBox {
                        font-size: poToRem(14);
                        padding-top: poToRem(16);
                        .miniItem {
                            p {
                                margin-left: poToRem(20);
                                line-height: poToRem(19);
                                margin-bottom: poToRem(16);
                            }
                            &.on p{
                                border-bottom: poToRem(1) solid rgba(255, 255, 255, 1);
                                padding-bottom: poToRem(16);
                                color: #ffffff;
                            }
                        }
                    }
                }
            }
        }
        .navIcon {
            width: poToRem(30);
            height: poToRem(30);
            display: inline-block;
        }
        .searchIcon {
            width: poToRem(32);
            height: poToRem(32);
            display: inline-block;
            transform: translateY(poToRem(-2));
        }
        &.light {
            .searchIcon {
                width: poToRem(32);
                height: poToRem(32);
                transform: translateY(poToRem(-2));
            }
        }
        .corange {
            // width: poToRem(158);
            height: poToRem(24);
            display: inline-block;
            vertical-align: top;
            // &.light {
            //     height: poToRem(18);
            //     margin-top: poToRem(2);
            // }
        }
    }
  
    @media only screen and (-webkit-device-pixel-ratio: 3) {
        .mHead {
            .top {
                .backBtn {
                    &::after {
                        width: poToRem(14);
                        height: poToRem(14);
                        border-width: poToRem(3);
                        -webkit-transform: rotate(-135deg) translateY(poToRem(24));
                        transform: rotate(-135deg) translateY(poToRem(24));
                    }
                }
            }
        }
    }
</style>
<style lang="scss">
    .mHead {
        .searchBox {
            input[type=text]:focus {
                border: none!important;
                border-color: #ffffff;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/base/mobile/mHead.vue